import { NavLink } from 'react-router-dom';

import { useTheme } from '../../hooks/useTheme';

import type { NavLinkEntry } from './config';
import { NAV_THEMES } from './nav-tokens';
import { sectionRowClass, sectionTone } from './navSectionRowClass';

interface NavEntryLinkProps {
  link: NavLinkEntry;
  /** Icon-only, for the rail; otherwise the labelled row. */
  collapsed: boolean;
  /** Called before navigating away, so the drawer can dismiss. */
  onNavigate?: () => void;
}

/** A top-level entry that is a single destination. It sits in line with the
 *  section rows and reads like one, but goes straight to its page. */
export default function NavEntryLink({ link, collapsed, onNavigate }: NavEntryLinkProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  const Icon = link.icon;

  return (
    <NavLink
      to={link.to}
      onClick={onNavigate}
      aria-label={link.label}
      title={link.label}
      className={`${sectionRowClass(collapsed)} no-underline`}
      style={({ isActive }) => sectionTone(t, isActive)}
    >
      <Icon size={18} aria-hidden className="shrink-0" />
      {!collapsed && <span>{link.label}</span>}
    </NavLink>
  );
}
